import { Dispatch } from "redux";

import {
  SetDemoAddressDispatchInterface,
  SET_DEMO_ADDRESS,
} from "../actionTypes/types";


export const SetDemoAddress =
  (address: any) => (dispatch: Dispatch<SetDemoAddressDispatchInterface>) => {
    dispatch({ type: SET_DEMO_ADDRESS, payload: address });
  };